import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllLayananDokumenByLayananID = createAsyncThunk(
  "layananDokumen/GetAllLayananDokumenByLayananID",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}master/layanan_dokumen/get_by_layanan_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

// TO FETCH ALL THE DOKUMEN | UPDATE HASIL REVISI
export const GetAllLayananDokumenUserByLayananID = createAsyncThunk(
  "layananDokumen/GetAllLayananDokumenUserByLayananID",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}user/get_upload_file_user_layanan/${data.id_layanan}/${data.id_user}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetAllLayananDokumen = createAsyncThunk(
  "layananDokumen/GetAllLayananDokumen",
  async (data, thunkAPI) => {
    let response;
    try {
      response = await axios.get(
        `${api}master/layanan_dokumen/all?${data.url}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleLayananDokumen = createAsyncThunk(
  "layananDokumen/GetSingleLayananDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/layanan_dokumen/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateLayananDokumen = createAsyncThunk(
  "layananDokumen/CreateLayananDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/layanan_dokumen`,
        {
          nama: data.nama,
          id_layanan: data.id_layanan,
          id_dokumen: data.id_dokumen,
          is_mandatory: data.is_mandatory,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditLayananDokumen = createAsyncThunk(
  "layananDokumen/EditLayananDokumen",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/layanan_dokumen/${data.id}`,
        {
          nama: data.nama,
          id_layanan: data.id_layanan,
          id_dokumen: data.id_dokumen,
          is_mandatory: data.is_mandatory,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteLayananDokumen = createAsyncThunk(
  "layananDokumen/DeleteLayananDokumen",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/layanan_dokumen/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(
          `${api}master/layanan_dokumen/all?${data.url}`,
          {
            headers: {
              Authorization: data.token,
            },
          }
        );

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const layananDokumenSlice = createSlice({
  name: "layananDokumen",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all Layanan dokumen by layanan id
    builder.addCase(GetAllLayananDokumenByLayananID.pending, loadingHandler);
    builder.addCase(GetAllLayananDokumenByLayananID.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananDokumenByLayananID.rejected, rejectedHandler);
    // get all users Layanan dokumen by layanan id
    builder.addCase(GetAllLayananDokumenUserByLayananID.pending, loadingHandler);
    builder.addCase(GetAllLayananDokumenUserByLayananID.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananDokumenUserByLayananID.rejected, rejectedHandler);
    // get all Layanan dokumen
    builder.addCase(GetAllLayananDokumen.pending, loadingHandler);
    builder.addCase(GetAllLayananDokumen.fulfilled, fulfilledHandler);
    builder.addCase(GetAllLayananDokumen.rejected, rejectedHandler);
    // get Single Layanan dokumen
    builder.addCase(GetSingleLayananDokumen.pending, loadingHandler);
    builder.addCase(GetSingleLayananDokumen.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleLayananDokumen.rejected, rejectedHandler);
    // create Layanan dokumen
    builder.addCase(CreateLayananDokumen.pending, loadingHandler);
    builder.addCase(CreateLayananDokumen.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateLayananDokumen.rejected, rejectedHandler);
    // edit Layanan dokumen
    builder.addCase(EditLayananDokumen.pending, loadingHandler);
    builder.addCase(EditLayananDokumen.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditLayananDokumen.rejected, rejectedHandler);
    // delete Layanan dokumen
    builder.addCase(DeleteLayananDokumen.pending, loadingHandler);
    builder.addCase(DeleteLayananDokumen.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isDelete: true });
    });
    builder.addCase(DeleteLayananDokumen.rejected, rejectedHandler);
  },
});

export const { reset } = layananDokumenSlice.actions;
export default layananDokumenSlice.reducer;
